import Header from '../components/Header';
import PartsPageContent from '../components/PartsPage';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const PartsPage = () => {
  return (
    <>
      <Header />
      <div style={{paddingTop: '64px'}}>
        <PartsPageContent />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default PartsPage;
